import {
  ActionStatus, IAction, withAsyncStatus
} from "@webiz/redux-common";
import {
  getUsersActions,
  getUsersDate,
  resetUsersStateAction,
  getUsersDetailsActions
} from "./UsersActions";

const initialAsyncState = {
  status: ActionStatus.INITIAL,
  usersData: [],
  usersDate: {},
  usersDetails: {},
  page: 1,
  lastPage: null,
  isFetched: true,
};

const initialState = {
  ...initialAsyncState,
};

export function UsersReducers(state = initialState, action: IAction) {
  switch (action.type) {
    case getUsersActions.REQUEST:
    case getUsersActions.SUCCESS:
    case getUsersActions.FAIL:
      return {
        ...state,
        ...(action.payload?.data && {
          usersData: action.payload.data.meta.current_page === 1 ? action.payload.usersData : [ ...state.usersData, ...action.payload.usersData ],
          page: action.payload.data.meta.current_page,
          lastPage: action.payload.data.meta.last_page,
          isFetched: action.payload.isFetched,
        }),
      };
    case getUsersDate.REQUEST:
    case getUsersDate.SUCCESS:
    case getUsersDate.FAIL:
      return {
        ...state,
        ...(action.payload && {
          usersDate: {
            start: action.payload.startDate,
            end: action.payload.endDate
          },
        }),
      };
    case getUsersDetailsActions.REQUEST:
    case getUsersDetailsActions.SUCCESS:
    case getUsersDetailsActions.FAIL:
      return {
        ...state,
        ...withAsyncStatus(
          state, action, getUsersDetailsActions,
        ),
      };
      case resetUsersStateAction.REQUEST:
      case resetUsersStateAction.SUCCESS:
      case resetUsersStateAction.FAIL:
        return {...initialState};
    default:
      return state;
  }
}
